import fetch from '@/utils/fetch'
import {API_PATH} from '@/config/env'
export const courseDetails = (objJson) => fetch(API_PATH + '/course/api/course/view', objJson, 'POST')
export const commonSign = (objJson) => fetch(API_PATH + '/course/auth/course/sign', objJson, 'POST')
export const courseLogSave = (objJson) => fetch(API_PATH + '/course/auth/course/record/save', objJson, 'POST')
export const isPlayOver = (objJson) => fetch(API_PATH + '/course/api/course/user/study/log/appPlayOver', objJson, 'POST')
export const getUserInfo = (objJson) => fetch(API_PATH + '/user/auth/user/ext/view', objJson, 'POST')
export const updataUserInfo = (objson) => fetch(API_PATH + '/user/auth/user/ext/update', objson, 'POST')
export const getCertificate = (objson) => fetch(API_PATH + '/course/auth/certificate/detail', objson, 'POST')
export const getWrongRecord = (objson) => fetch(API_PATH + '/exam/auth/practice/wrong/record', objson, 'POST')
export const choosePicture = (objson) => fetch(API_PATH + '/course/api/upload/pic', objson, 'POST')
export const signIn = (objson) => fetch(API_PATH + '/course/auth/offline/lecture/sign/in', objson, 'POST')
export const grading = (objson) => fetch(API_PATH + '/course/auth/offline/lecture/grading', objson, 'GET')
export const subAssetment = (objson) => fetch(API_PATH + '/course/auth/offline/lecture/instructor', objson, 'POST')
export const getExamInfo = (objson) => fetch(API_PATH + '/exam/auth/practical/getExamInfo', objson, 'POST')
export const intoRoom = (objson) => fetch(API_PATH + '/exam/auth/practice/join/' + objson.roomId, {}, 'GET')
export const intoManageRoom = (objson) => fetch(API_PATH + '/exam/pc/practice/join/' + objson.roomId, {}, 'GET')
export const getCourseInfo = (objson) => fetch(API_PATH + '/course/auth/offline/lecture/getCourse', objson, 'POST')

export const updateExamSession = (objson) => fetch(API_PATH + '/exam/auth/practical/updateExamSession', objson, 'POST')// 修改考试状态
// export const getAnswer = (objson) => fetch(API_PATH + '/exam/auth/practice/' + objson + '/answer/put', {}, 'GET')// 获取答案

export const deleteWrongRecord = (objson) => fetch(API_PATH + '/exam/auth/practice/wrong/record/delete', objson, 'POST')// 删除错题

export const getEnteredInfo = (objson) => fetch(API_PATH + '/exam/auth/beipei', {}, 'GET')// 获取考试批次
export const saveEnteredInfo = (objson) => fetch(API_PATH + '/exam/auth/beipei', objson, 'POST')// 保存报名信息
// export const weixinToken = (objson) => fetch('/weixin/', objson, 'GET')

// 理论(北培)考试成绩查询
export const getResult = (objson) => fetch(API_PATH + '/course/auth/course/evaluation/result/select', objson, 'POST')
// 是否满足北培考试报名申请条件
export const checkApplyCon = (objson) => fetch(API_PATH + '/course/auth/course/evaluation/result/check', objson, 'POST')

export const checkExamPayType = (objson) => fetch(API_PATH + '/course/auth/course/evaluation/result/check/examPayType', objson, 'POST')

// 自评合格成绩列表
export const selectCertList = (objson) => fetch(API_PATH + '/exam/auth/self/asses/test/certList', objson, 'POST')
export const selectVerifyLog = (objson) => fetch(API_PATH + '/exam/auth/self/asses/test/verifyLog', objson, 'POST')
// 合格 详情
export const getCertInfo = (objson) => fetch(API_PATH + '/exam/auth/self/asses/test/certInfo', objson, 'POST')

export const getExamList = (objson) => fetch(API_PATH + '/exam/auth/beipei/bankExam?idcard='+objson.idcard+'&bankNo='+objson.bankNo, {}, 'GET')

export const getExamPdfUrl = (objson) => fetch(API_PATH + '/exam/auth/beipei/getTicketPdfUrl', {}, 'GET')

// 获取地区列表
export const getAreaList = () => fetch(API_PATH + '/common/area/list', {}, 'GET')

// 获取银行列表
export const getBankList = (objson) => fetch(API_PATH + '/exam/auth/beipei/bankList?province='+objson.province+'&city='+objson.city, {}, 'GET')



// WEBPACK FOOTER //
// ./src/api/common.js